import { render, staticRenderFns } from "./ConsultaPCA.vue?vue&type=template&id=5f8229f8&scoped=true"
import script from "./ConsultaPCA.vue?vue&type=script&lang=js"
export * from "./ConsultaPCA.vue?vue&type=script&lang=js"
import style0 from "./ConsultaPCA.vue?vue&type=style&index=0&id=5f8229f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8229f8",
  null
  
)

export default component.exports